// Module includes
import service from './service';

export default  angular.module('app.panels.module.configEmailNotification', [])
    .service("ConfigEmailNotificationService", service)
    .name;



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/configEmailNotification/index.js
 **/